

// A helper class for checking external link click events
var Anchors = function(windowHostname) {
  this.windowHostname = windowHostname;
};
/**
  * Returns true/false indicating whether the anchor element is for an external
  * link or not.
  */
Anchors.prototype.isExternal = function(anchor) {
  var result = false;

  if (anchor && (anchor instanceof HTMLAnchorElement)) {
    var anchorHostname = anchor.hostname;
    var url = anchor.href;

    if (url) {
      if (
        // we look for `endsWith` rather than equality, to cover sub-domains
        // of our primary domain.
        (! anchorHostname.endsWith(this.windowHostname)) ||
        url.startsWith('mailto:') || 
        url.startsWith('tel:')
      ) {
        result = true;
      }
    }
  }


  return result;
};
/**
 * Returns true/false indicating whether the anchor element will open in a new
 * tab or not.
 */
Anchors.prototype.opensInNewTab = function(anchor) {
  var result = false;

  if (anchor && (anchor instanceof HTMLAnchorElement)) {
    if (
      (anchor.target == '_blank') ||
      anchor.href.startsWith('mailto:') || 
      anchor.href.startsWith('tel:')
    ) {
      result = true;
    }
  }


  return result;
};


export default new Anchors(window.location.hostname);

